(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-section-type]';
  const API_CONTENT_SELECTOR = '[data-api-content]';
  const LOCAL_STORAGE_KEY = 'shopify_recently_viewed_local';

  if (customElements.get('recently-viewed')) {
    return;
  }

  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest(SECTION_SELECTOR);
        this.howManyToShow = parseInt(this.dataset.limit, 10) || 3;
        this.target = this.dataset.target;
        this.wrapperId = this.dataset.wrapperId || this.id;
        this.currentProductHandle = this.dataset.productHandle || '';
      }

      connectedCallback() {
        const localHistory = this.getLocalHistory();
        this.recordLocalHistory(localHistory);

        if (Shopify.Products.hasProducts) {
          this.showShopifyHistory();
          return;
        }

        this.showLocalHistory(localHistory);
      }

      showShopifyHistory() {
        Shopify.Products.showRecentlyViewed({
          howManyToShow: this.howManyToShow,
          wrapperId: this.wrapperId,
          section: this.section,
          target: this.target,
          onComplete: () => this.dispatchLoadedEvent(),
        });
      }

      async showLocalHistory(localHistory) {
        const wrapper = document.getElementById(this.wrapperId);

        if (!wrapper || !this.target) {
          return;
        }

        const handles = localHistory
          .filter((handle) => handle && handle !== this.currentProductHandle)
          .slice(0, this.howManyToShow);

        for (const [index, handle] of handles.entries()) {
          try {
            const response = await fetch(
              `${window.theme.routes.root}products/${handle}?section_id=${this.target}`
            );

            if (!response.ok) {
              continue;
            }

            let productHTML = await response.text();
            const aosAnchor = wrapper.id ? `#${wrapper.id}` : '';

            productHTML = productHTML
              .replaceAll('||itemAnimationDelay||', index * 100)
              .replaceAll('||itemAnimationAnchor||', aosAnchor);

            const fresh = document.createElement('div');
            fresh.innerHTML = productHTML;

            const apiContent = fresh.querySelector(API_CONTENT_SELECTOR);
            if (apiContent) {
              wrapper.insertAdjacentHTML('beforeend', apiContent.innerHTML);
            }
          } catch (error) {
            // Ignore unavailable products and continue loading the remaining history.
          }
        }

        this.dispatchLoadedEvent();
      }

      getLocalHistory() {
        try {
          const history = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');
          return Array.isArray(history) ? history : [];
        } catch (error) {
          return [];
        }
      }

      recordLocalHistory(history) {
        if (!this.currentProductHandle) {
          return;
        }

        const nextHistory = [
          this.currentProductHandle,
          ...history.filter((handle) => handle !== this.currentProductHandle),
        ].slice(0, 10);

        try {
          localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(nextHistory));
        } catch (error) {
          // Browsing history remains optional when storage is unavailable.
        }
      }

      dispatchLoadedEvent() {
        this.dispatchEvent(
          new CustomEvent('theme:recently-viewed:loaded', {
            bubbles: false,
          })
        );
      }
    }
  );
})();
